import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useDataTableContext } from "@msuite/ui/table";
import type { GetOrdersQuerySchema } from "@msuite/utils/schemas";
import type { Enums } from "@msuite/utils/types";
import { Fragment } from "react";
import { Can } from "@/components/citadel/can";
import { AddOrderModal } from "@/modals/stock/add-order-modal";
import { OrdersStateFilter } from "./orders-state-filter";

/** Props Interface */
interface OrdersMenuProps {
	query?: GetOrdersQuerySchema;
	state: Enums<"orderState"> | "all";
	onStateChange: (state: Enums<"orderState"> | "all") => void;
}

export function OrdersMenu({ query, state, onStateChange }: OrdersMenuProps) {
	/** Context */
	const { refetch } = useDataTableContext();

	/** Hooks */
	const { t } = useTranslation();
	const disclosure = useDisclosure();

	/** Render */
	return (
		<Fragment>
			<OrdersStateFilter
				state={state}
				onChange={onStateChange}
			/>
			<Can
				action="create"
				subject="Stock"
			>
				<Button
					icon={<Icon name="Plus" />}
					onClick={disclosure.onOpen}
					variant="primary"
				>
					{t("stock.add_order")}
				</Button>
			</Can>
			{disclosure.isOpen && (
				<AddOrderModal
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					onComplete={refetch}
					// Only the project carries over as a value: the reach is not a form field, it is
					// what the project picker offers.
					defaultValues={{ projectId: query?.projectId }}
					projectScope={query?.scope}
				/>
			)}
		</Fragment>
	);
}
